import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TrashIcon, XMarkIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "../../ui";

export const RiskDeleteConfirmationModal = ({ isOpen, onClose, riskDelete, risk }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    {/* Backdrop */}
                    <motion.div
                        key="backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm"
                        onClick={onClose}
                    />

                    {/* Modal Panel */}
                    <motion.div
                        key="modal"
                        initial={{ opacity: 0, y: -24, scale: 0.97 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 16, scale: 0.97 }}
                        transition={{ duration: 0.22, ease: "easeOut" }}
                        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm flex flex-col overflow-hidden"
                    >
                        {/* Header */}
                        <div className="flex items-center gap-4 px-6 py-5 bg-gradient-to-r from-red-600 to-red-500 rounded-t-2xl">
                            <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                                <TrashIcon className="w-5 h-5 text-white" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="text-base font-semibold text-white leading-tight">
                                    Delete Risk
                                </h3>
                                <p className="text-xs text-red-100 mt-0.5">
                                    This action cannot be undone
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={onClose}
                                className="flex-shrink-0 p-1.5 text-white/70 hover:text-white hover:bg-white/20 rounded-lg transition-colors"
                            >
                                <XMarkIcon className="w-5 h-5" />
                            </button>
                        </div>

                        {/* Body */}
                        <div className="px-6 py-5">
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-9 h-9 rounded-full bg-red-50 flex items-center justify-center mt-0.5">
                                    <ExclamationTriangleIcon className="w-5 h-5 text-red-500" />
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-900">
                                        Are you sure you want to delete{" "}
                                        <span className="font-semibold text-red-600">{risk?.risk_id}</span>?
                                    </p>
                                    <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                                        This risk and all its associated data will be permanently removed from the register.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50/80 rounded-b-2xl">
                            <Button type="button" variant="secondary" size="sm" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button type="button" variant="danger" size="sm" onClick={riskDelete}>
                                Delete Risk
                            </Button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};
